import { render, staticRenderFns } from "./ClientesNaCaixa.vue?vue&type=template&id=6ef12af3&scoped=true&"
import script from "./ClientesNaCaixa.vue?vue&type=script&lang=js&"
export * from "./ClientesNaCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef12af3",
  null
  
)

export default component.exports